import SiteNavbar from '../../components/feature/SiteNavbar';
import FooterSection from '../home/components/FooterSection';
import RefHero from './components/RefHero';
import RefGrid from './components/RefGrid';
import RefTestimonials from './components/RefTestimonials';
import RefCTA from './components/RefCTA';

export default function ReferencePage() {
  return (
    <div className="bg-zinc-950 min-h-screen">
      <SiteNavbar />
      <main>
        <RefHero />
        <RefGrid />
        <RefTestimonials />
        <RefCTA />
      </main>
      <FooterSection />
    </div>
  );
}
